import { render, staticRenderFns } from "./Veranstaltungen.vue?vue&type=template&id=49842a4d&scoped=true&"
import script from "./Veranstaltungen.vue?vue&type=script&lang=js&"
export * from "./Veranstaltungen.vue?vue&type=script&lang=js&"
import style0 from "./Veranstaltungen.vue?vue&type=style&index=0&id=49842a4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49842a4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
